'use client'

import { useState } from 'react'
import useSWR from 'swr'
import toast from 'react-hot-toast'
import apiService from '@/app/services/apiService'
import CreateContractModal from '../modals/CreateContractModal'
import { formatCurrency, formatFullDate } from '@/app/utils/format';

export default function VendorConfirmedReservations() {
  const { data, error, isLoading, mutate } = useSWR(
    '/api/products/vendor-reservations/',
    (url) => apiService.getWithToken(url)
  )

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeReservationId, setActiveReservationId] = useState<string | null>(null)

  const handleCreateContract = (reservationId: string) => {
    setActiveReservationId(reservationId)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setActiveReservationId(null)
  }

  if (isLoading) return <p>Carregando reservas confirmadas...</p>
  if (error) return <p className="text-red-500">Erro ao carregar reservas.</p>
  if (!data || data.length === 0) return <p>Nenhuma reserva confirmada sem contrato.</p>

  return (
    <div className="grid gap-4 mt-6 justify-center">
      <h2 className="text-xl font-semibold">Reservas confirmadas sem contrato</h2>

      {data
        .filter((res: any) => res.status === 'confirmed' && !res.contract_exists)
        .map((reservation: any) => (
          <div
            key={reservation.id}
            className="p-4 border rounded-lg flex justify-between items-center"
          >
            <div>
              <p className="font-semibold">{reservation.product_title}</p>
              <p className='text-xm text-red-600'>Salve em algum lugar! Após a criação do contrato esses dados não estarão mais disponíveis!</p>
              <p className="text-sm text-gray-600">
                Nome completo: {reservation.created_by_full_name}
              </p>
              <p className="text-sm text-gray-600">
                Cidade: {reservation.created_by_city}
              </p>
              <p className="text-sm text-gray-600">
                Local: {reservation.created_by_place}
              </p>

              <p className="text-sm text-gray-600">
                CPF/CNPJ: {reservation.created_by_cpf_cnpj}
              </p>

              <p className="text-sm text-gray-600">
                Endereço: {reservation.created_by_address}
              </p>
              <p className="text-sm text-gray-600">Email: {reservation.created_by_email}</p>
              <p className="text-sm">Total pago: {formatCurrency(reservation.total_price)}</p>
              <p className="text-sm text-gray-600">
                Data do evento: {formatFullDate(reservation.start_date)} a {formatFullDate(reservation.end_date)}
              </p>
              <button
                onClick={() => handleCreateContract(reservation.id)}
                className="py-2 px-4 w-full bg-blue-600 mt-4 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Criar contrato
              </button>
            </div>              
          </div>
        ))}

      {activeReservationId && (
        <CreateContractModal
          reservationId={activeReservationId}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onCreated={() => {
            toast.success('Contrato criado com sucesso!')
            handleCloseModal()
            mutate() // atualiza lista de reservas
          }}
        />
      )}
    </div>
  )
}
